import { GenerationPreset } from "@next-platform/packages-ts-types";
import { Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import { useCallback } from "react";

import Trans from "@/components/Trans/Trans";

interface IPresetSelectionItemProps {
  preset: GenerationPreset;
  modelName: string;
  onSelect: (preset: GenerationPreset) => void;
}

const PresetSelectionItem = ({ preset, modelName, onSelect }: IPresetSelectionItemProps) => {
  const handleSelect = useCallback(() => {
    onSelect(preset);
  }, [onSelect, preset]);

  return (
    <div className="flex flex-col gap-1 px-[18px] py-3 cursor-pointer hover:bg-gray-3 dark:hover:bg-gray-5 transition-colors" onClick={handleSelect}>
      <Text variant={TextVariants.LABEL_MEDIUM_MEDIUM} className="text-gray-12">
        {preset.name}
      </Text>
      <div className="flex flex-col gap-0.5">
        <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="text-gray-10 text-xs">
          <Trans i18nKey="chat:page.header.modelSelection.dropdown.presets.modelAndTokens" values={{ modelName, tokens: preset.maxNewTokens }} />
        </Text>
        <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="text-gray-11 text-xs">
          <Trans
            i18nKey="chat:page.header.modelSelection.dropdown.presets.generationSettings"
            values={{ temp: preset.temperature.toFixed(2), topP: preset.topP.toFixed(2), topK: preset.topK }}
          />
        </Text>
      </div>
    </div>
  );
};

export default PresetSelectionItem;
